module.exports = __webpack_public_path__ + "static/media/pranjal-tank.60895306.jpeg";